export default __webpack_public_path__ + "275b0b5b447c130a3a9cc12c64ca8d86.svg";